function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { getOriginalFunction } from '@sentry/utils';
var originalFunctionToString;

/** Patch toString calls to return proper name for wrapped functions */
var FunctionToString = /*#__PURE__*/function () {
  function FunctionToString() {
    _classCallCheck(this, FunctionToString);
    FunctionToString.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */
  _createClass(FunctionToString, [{
    key: "__init",
    value:
    /**
     * @inheritDoc
     */
    function __init() {
      this.name = FunctionToString.id;
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "setupOnce",
    value: function setupOnce() {
      originalFunctionToString = Function.prototype.toString;
      Function.prototype.toString = function () {
        var context = getOriginalFunction(this) || this;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return originalFunctionToString.apply(context, args);
      };
    }
  }], [{
    key: "__initStatic",
    value: function __initStatic() {
      this.id = 'FunctionToString';
    }
  }]);
  return FunctionToString;
}();
FunctionToString.__initStatic();
export { FunctionToString };